import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["categories", "hsSoftwareCategories", "menuOpen", "selectedFilterType", "selectedGroup", "setMenuOpen", "onClickOption"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import MobileNestedMenu from 'academy-common-lib/components/Modals/FullScreenModal/MobileNestedMenu';
import { FILTER_TYPES_OTHER } from 'academy-common-lib/constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParamSingleSelect } from 'academy-common-lib/hooks/searchParamHooks';
import UsageTracker from '../../utils/UsageTracker';
import { PanelSection } from 'academy-common-lib/components/Modals/FullScreenModal/PanelSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileCatalogSelector = _ref => {
  let {
      categories,
      hsSoftwareCategories,
      menuOpen,
      selectedFilterType,
      selectedGroup,
      setMenuOpen,
      onClickOption
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const filterTypeCategories = FILTER_TYPES_OTHER.CATEGORIES;
  const filterTypeTools = FILTER_TYPES_OTHER.TOOLS;
  const [__, setCatalogFilter] = useSearchParamSingleSelect();
  const trackFilterSelect = (selectedOption, filterType) => {
    UsageTracker.track('filterInteraction', {
      action: 'filter-selected',
      value: selectedOption,
      key: filterType,
      isDropdown: true
    });
  };
  const handleOnClickOption = (selectedOption, filterType) => {
    setCatalogFilter(filterType, selectedOption);
    trackFilterSelect(selectedOption, filterType);
    setMenuOpen(false);
    onClickOption === null || onClickOption === void 0 || onClickOption(selectedOption, filterType);
  };
  const renderLevel2Items = (category, filterType) => category.map(subcat => /*#__PURE__*/_jsx(Button, {
    "data-test-id": `option-${subcat}`,
    onClick: () => {
      handleOnClickOption(subcat, filterType);
    },
    use: "unstyled",
    children: /*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      justifyContent: "space-between",
      paddingBlock: "300",
      paddingInline: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.${subcat}`
      })
    })
  }, subcat));
  const renderCategoryHeading = (index, filterType) => /*#__PURE__*/_jsx(Text, {
    color: "text-core-default",
    textAlign: "left",
    children: /*#__PURE__*/_jsx(PanelSection, {
      showBorders: false,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}group.${index}`
      })
    })
  });
  const getSubPage = (category, index, filterType) => /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderCategoryHeading(index, filterType), renderLevel2Items(category, filterType)]
  });
  const renderLevel1Items = (items, filterType) => items.map((category, index) => {
    return /*#__PURE__*/_jsx(Button, {
      "data-test-id": `option-${index}`,
      onClick: typeof category === 'object' ? undefined : () => {
        handleOnClickOption(index, filterType);
      },
      paddingBlock: "300",
      paddingInline: "500"
      // @ts-expect-error Untyped. Part of cards logic.
      ,
      subpage: typeof category === 'object' ? getSubPage(category, index, filterType) : null,
      use: "unstyled",
      children: /*#__PURE__*/_jsxs(Flex, {
        inlineSize: "100%",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: typeof category === 'object' ? `learningCenter.topFilters.${filterType}group.${index}` : `learningCenter.topFilters.${filterType}.${index}`
        }), typeof category === 'object' && /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(RightIcon, {
            color: "icon-core-subtle"
          })
        })]
      })
    }, index);
  }).toArray();
  const getIndexOfSelectedGroup = categoryGroups => categoryGroups.keySeq().findIndex(k => k === selectedGroup);
  const getSelectedPageIndex = () => {
    if (selectedGroup) {
      return selectedFilterType === filterTypeCategories ? getIndexOfSelectedGroup(categories) + 1 : getIndexOfSelectedGroup(hsSoftwareCategories) + categories.size + 2;
    }
    return -1;
  };
  return /*#__PURE__*/_jsxs(MobileNestedMenu, Object.assign({
    indented: false,
    open: !!menuOpen,
    selectedPage: getSelectedPageIndex(),
    setIsOpen: setMenuOpen,
    useSidePanel: false
  }, restProps, {
    children: [/*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      textAlign: "left",
      children: /*#__PURE__*/_jsx(PanelSection, {
        showBorders: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.categories.categories"
        })
      })
    }), renderLevel1Items(categories, filterTypeCategories), /*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      textAlign: "left",
      children: /*#__PURE__*/_jsx(PanelSection, {
        showBorders: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.categories.hubspotSoftware"
        })
      })
    }), renderLevel1Items(hsSoftwareCategories, filterTypeTools)]
  }));
};
export default MobileCatalogSelector;